/**
 * SmoothScrolljs
 * File for smooth scroll effect in anchor links
 */

jQuery(document).ready(function($) {
    var $root = $('html, body');
    $('a.scroll').click(function () {
        var url = ($(this).attr('href'));
        if (url != '#' && url != '#/') {
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 500);
        }
        return false;
    });

});
